import { SendWhatsappButton } from "./SendWhatsappButton"

export default SendWhatsappButton
